import { RouteObject } from "react-router-dom";
import { Suspense, lazy } from "react";
import GeneralLayout from "src/user.InterfaceLayer/Layouts/General.layout";
import Error from "src/user.InterfaceLayer/Components/UI-KIT/Error";
import { NotFoundPage } from "src/user.InterfaceLayer/Pages/NotFound.page";

const ContactsPage = lazy(() =>
	import("../../../../old/PagesGeneral/Contacts").then((module) => ({
		default: module.ContactsPage,
	}))
);

const OrganizationInfoPage = lazy(() =>
	import("../../../../old/PagesGeneral/OrganizationInfo").then((module) => ({
		default: module.OrganizationInfoPage,
	}))
);

const AssociationPage = lazy(() =>
	import("../../../../old/PagesGeneral/AssociationPage").then((module) => ({
		default: module.AssociationPage,
	}))
);

const FormPage = lazy(() =>
	import("../../../../old/PagesGeneral/Form").then((module) => ({
		default: module.CrmFormPage,
	}))
);

const GeneralPagesRouter: RouteObject[] = [
	{
		path: "",
		element: <GeneralLayout />,
		children: [
			{
				path: "/contacts",
				element: (
					<Suspense>
						<ContactsPage />
					</Suspense>
				),
				errorElement: <Error />,
			},
			{
				path: "/organization-info",
				element: (
					<Suspense>
						<OrganizationInfoPage />
					</Suspense>
				),
				errorElement: <Error />,
			},
			{
				path: "/organization-info/:id/*",
				element: (
					<Suspense>
						<OrganizationInfoPage />
					</Suspense>
				),
				errorElement: <Error />,
			},
			{
				path: "/association",
				element: (
					<Suspense>
						<AssociationPage />
					</Suspense>
				),
				errorElement: <Error />,
			},
			{
				path: "/forms/:id/*",
				element: (
					<Suspense>
						<FormPage />
					</Suspense>
				),
				errorElement: <Error />,
			},
			{
				index: true,
				path: "*",
				element: <NotFoundPage />,
			},
		],
	},
];

export default GeneralPagesRouter;
